import React, { Component } from 'react';
import Header from "../component/header/HeaderFour";
import WhatsAppButton from "../component/WhatsAppButton";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Footer from "../component/footer/FooterTwo";

import { withTranslation } from 'react-i18next';

class Error404 extends Component {
    
    render() {
        const { t } = this.props;

        return (
            <>
                <Header headerPosition="header--transparent" color="color-white" logo="logo-light" />
                
                {/* Start Page Error */}
                <div className="error-page-inner bg_color--4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="inner">
                                    <h1 className="title theme-gradient">404!</h1>
                                    <h3 className="sub-title">{t('titulo_404')}</h3>
                                    <span>{t('texto_404')}</span>
                                    <div className="error-button">
                                        <a className="rn-button-style--2 btn-solid" href="/">{t('boton_backhome')}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Error */}

                {/* Start Whatsapp Button */}
                <div>
                    <WhatsAppButton />
                </div>
                {/* End Whatsapp Button */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer /> 
            </>
        )
    }
}

export default withTranslation()(Error404);
